var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConverted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22615_99840)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22615_99840)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22615_99840",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0.000488281H0V23.0005H23V0.000488281Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22615_99840)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_22615_99840",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000490189H23V23.0005H0V0.000490189Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_22615_99840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7017 3.14077V1.43648C12.7017 0.624113 13.1718 0.429421 13.7462 1.00384L17.5655 4.82314C18.1399 5.39756 18.1399 6.3375 17.5655 6.91201L13.7462 10.7314C13.1718 11.3058 12.7017 11.111 12.7017 10.2987V8.59429C11.9457 8.4155 11.1582 8.31802 10.3475 8.31802C6.96706 8.31802 3.97247 9.96476 2.11792 12.4985C2.76372 7.22552 7.25424 3.14077 12.7017 3.14077Z",
    stroke: "white",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 19.864V21.5683C10.2995 22.3807 9.8295 22.5754 9.25504 22.0009L5.43569 18.1817C4.86128 17.6072 4.86128 16.6673 5.43569 16.0929L9.25504 12.2735C9.8295 11.699 10.2995 11.8938 10.2995 12.7061V14.4106C11.0556 14.5893 11.843 14.6868 12.6537 14.6868C16.0342 14.6868 19.0287 13.0401 20.8833 10.5063C20.2375 15.7793 15.7469 19.864 10.2995 19.864Z",
    stroke: "white",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22615_99840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22615_99840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverted);
export default __webpack_public_path__ + "static/media/converted.8310ad9ca1a0c2b8973e1654442c26e5.svg";
export { ForwardRef as ReactComponent };